import { resourceRequestUrls } from "@/utils/messageUrl";
import http from "./httpVideo";
import { BaseResponseType } from "@/types/message";
import { Resource } from "@/types/resource";

const baseUrlResource = "/v1/api/resource";

const { get,post } = http;

export const getUrlByObjectKey = (path: string) =>
  get(`${baseUrlResource}/resource/get/default/temporary/url/${path}`); //获取默认资源临时下载地址

export const getUrlByObjectKeyWithHit = (path: string) =>
  get(`/community-api/community/file/cdn/access-url?fileKey=${path}`);

/**
 * 获取banner
 * @param params 
 * @returns 
 */
export const getBannerList = (params: any) =>
  get(`${resourceRequestUrls.getBannerList}?module=${params}`); 

/**
 * 查询所有资源分类
 */
export const getFreeDownloadCategory = () =>
  get(`${resourceRequestUrls.getFreeDownloadCategory}`);

/**
 * 查询资源详情
 * @param id 
 * @returns 
 */
export const getFreeDownloadDetail = (id: any) =>
  get(`${resourceRequestUrls.getFreeDownloadDetail}?resourceId=${id}`);

/**
 * 查询资源下载链接
 * @param id 
 * @returns 
 */
export const getResourceDownloadUrl= (id: string) =>
  get(`${resourceRequestUrls.getResourceDownloadUrl}?resourceDetailId=${id}`); 

/**
 * 快速指引下载
 * @param id 
 * @returns 
 */
export const getResourceGuideDownloadUrl = (id: string):Promise<BaseResponseType<Resource.DownloadResponseType>> =>
  get(`${resourceRequestUrls.getResourceGuideDownloadUrl}?resourceGuideId=${id}`);

/**
 *下载全部 用于多选下载
 * @param ids 
 * @returns 
 */
export const getBatchResourceDownloadUrl= (ids: any):Promise<BaseResponseType<{data:Resource.DownloadResponseType,id:string}[]>> =>
  post(`${resourceRequestUrls.getBatchResourceDownloadUrl}`,ids);

/**
 * 获取概览信息
 * @returns 
 */
export const getFreeDownloadOverview = ():Promise<BaseResponseType<Resource.ResourceOverview>> =>
  post(`/community-api/community/resource/getOverview`);

/**
 * 获取用户提问的问题列表
 * @param params 
 * @returns 
 */
export const getDownloadUserList=(params:any):Promise<BaseResponseType>=>{
  return post(`${resourceRequestUrls.getDownloadUserList}`,params)
}
/**
 * 获取用户签署的协议列表
 * @param params 
 * @returns 
 */
export const getAgreementList=(params:any):Promise<BaseResponseType>=>{
  return post(`${resourceRequestUrls.getAgreementList}`,params)
}